"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_radio_group_1 = require("../radio/awsui-radio-group");
var awsui_form_field_1 = require("../form-field/awsui-form-field");
var BaseCollectionPageSizeSelectorWrapper = /** @class */ (function (_super) {
    __extends(BaseCollectionPageSizeSelectorWrapper, _super);
    function BaseCollectionPageSizeSelectorWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseCollectionPageSizeSelectorWrapper.prototype.findTitle = function () {
        var formField = new awsui_form_field_1.default(this.find('awsui-form-field').getElement());
        return formField.findLabel();
    };
    BaseCollectionPageSizeSelectorWrapper.prototype.findOptions = function () {
        var group = new awsui_radio_group_1.default(this.find('awsui-radio-group').getElement());
        return group.findButtons();
    };
    return BaseCollectionPageSizeSelectorWrapper;
}(dom_1.ComponentWrapper));
exports.BaseCollectionPageSizeSelectorWrapper = BaseCollectionPageSizeSelectorWrapper;
var TablePageSizeSelectorWrapper = /** @class */ (function (_super) {
    __extends(TablePageSizeSelectorWrapper, _super);
    function TablePageSizeSelectorWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TablePageSizeSelectorWrapper;
}(BaseCollectionPageSizeSelectorWrapper));
exports.default = TablePageSizeSelectorWrapper;
//# sourceMappingURL=awsui-table-page-size-selector.js.map